import React, { useEffect, useState } from "react";
import { Table, Card, Button, Dropdown, Menu, Upload, message } from "antd";
import { MenuOutlined, UploadOutlined } from "@ant-design/icons";
import { fetchData, postData, toLocalDateTime } from "../../../utils.js";
import { ExcelRenderer } from "react-excel-renderer";
import EditOrderModel from "../components/EditOrderModel.js";
import { Form, Input } from "antd";
import { Modal } from 'antd'; // Import Modal from antd
import axios from 'axios';

const UploadedOrdersTab = () => {
    //const [orders, setOrders] = useState([]);
    //const [excelData, setExcelData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allOrders, setAllOrders] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingOrder, setEditingOrder] = useState(null);
    const [form] = Form.useForm();




    useEffect(() => {
        console.log("All Orders Updated:", allOrders);
    }, [allOrders]);



    // useEffect(() => {
    //     setLoading(true);
    //     fetchData(window.SiteBasePath + "/api/OrdersAutomation/GetOrders")
    //         .then((resp) => {
    //             console.log("API Response:", resp);
    //             if (resp && resp.length > 0) {
    //                 setOrders(resp);
    //             } else {
    //                 console.error("Invalid response format:", resp);
    //                 // Handle invalid response format
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("Error fetching orders:", error);
    //             // Handle fetch error
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }, []);

    const onAction = ({ action, item }) => {

        if (action === "EDIT") {
            setEditingOrder(item);
            console.log("Editing Order:", item);
            form.setFieldsValue(item); // Prefill form with selected order data
            setIsModalVisible(true);
            console.log("Modal visibility set to true"); // Debugging line
        }
        else if (action === "DELETE") {
            handleDeleteOrder(item.OrderId);
        }
        // Handle action (e.g., delete, edit)
        console.log({ action, item });
    };

    const handleDeleteOrder = (orderId) => {
        setAllOrders(prevOrders => prevOrders.filter(order => order.OrderId !== orderId));
        message.success('Order deleted successfully!');
    };

    const handleUpdateOrder = (updatedOrder) => {
        setAllOrders(prevOrders => {
            const updatedOrders = prevOrders.map(order =>
                order.OrderId === updatedOrder.OrderId 
                    ? { ...order, ...updatedOrder } 
                    : order
            );
            return [...updatedOrders]; // Return a new array to trigger re-render
        });
        setIsModalVisible(false);
    };


    const handlePreviewAllOrders = async (OrdersToSave) => {
        Modal.confirm({
            title: 'All Orders Available for Preview',
            content: `You have ${OrdersToSave.length} orders. If you want to edit, Click on Edit!`,
            onOk: async () => {
                setLoading(true);
                try {
                    await checkDuplicateOrders(OrdersToSave);
                    console.log("Saving all orders:", OrdersToSave); // Log orders data
                    //const resp = await postData(window.SiteBasePath + "/api/OrdersAutomation/SaveOrders", OrdersToSave);
                    message.success('Orders Ready to Preview! Click on the "Edit" button to make changes.');
                } catch (error) {
                    message.error('Failed to save orders.');
                    console.error('Failed to save orders.', error);
                } finally {
                    setLoading(false);
                }
            },
            onCancel() {
                console.log('Save cancelled');
            },
        });
    };

    const checkDuplicateOrders = async (orders) => {
        setLoading(true);
        try {
            console.log("Checking for duplicate orders:", orders); // Log orders data
            const resp = await postData(window.SiteBasePath + "/api/OrdersAutomation/CheckDuplicateOrders", orders);
            if (resp.duplicates && resp.duplicates.length > 0) {
                Modal.info({
                    title: 'Duplicate Orders Found',
                    content: `The following orders are duplicates: ${resp.duplicates.join(', ')}`,
                });
                return true; // Duplicates found
            } else {
                message.success('No duplicate orders found.');
                return false; // No duplicates
            }
        } catch (error) {
            message.error('Failed to check for duplicate orders.');
            console.error('Failed to check for duplicate orders.', error);
            return true; // Assume duplicates found in case of error
        } finally {
            setLoading(false);
        }
    };

    const handleSaveOrder = async (orders) => {

        if (orders.length === 0) {
            message.error('No orders to save.');
            return;
        }


        setLoading(true);
        try {
            const hasDuplicates = await checkDuplicateOrders(orders);
            if (hasDuplicates) {
                
                return;
            }
            // Replace with the actual API endpoint
            const resp = await postData(window.SiteBasePath + "/api/OrdersAutomation/SaveOrders", orders);
            console.log("API Response Create:", resp);
            message.success('Order saved successfully!');
            setAllOrders([]); 
        } catch (error) {
            message.error('Failed to save order.', error);
            console.error('Failed to save order.', error);
        } finally {
            setLoading(false);
        }
    };



    const handleFileUpload = (file) => {
        ExcelRenderer(file, (err, resp) => {
            if (err) {
                console.error(err);
                message.error("Error reading Excel file");
            } else {
                const ordersMap = {};
                const headerRow = resp.rows[0];
                console.log("Header Row:", headerRow); // Log the first row for debugging
                resp.rows.forEach((row) => {
                    const orderId = row[0];
                    const orderItemId = row[1];
                    const sku = row[8];
                    const quantity = parseInt(row[11], 10);

                    if (!ordersMap[orderId]) {
                        ordersMap[orderId] = {
                            OrderId: orderId,
                            PurchaseDate: row[2],
                            BuyerEmail: row[4],
                            BuyerName: row[5],
                            BuyerPhoneNumber: row[7],
                            RecipientName: row[21],
                            ShipAddress1: row[22],
                            ShipAddress2: row[23],
                            ShipAddress3: row[24],
                            ShipCity: row[26],
                            ShipState: row[27],
                            ShipPostalCode: row[28],
                            ShipCountry: row[29],
                            ShipPhoneNumber: row[30],
                            AddressType: row[25],
                            Currency: row[12],
                            ShippingPrice: parseFloat(row[15]),
                            ShippingTax: parseFloat(row[16]),
                            ShipServiceLevel: row[19],
                            OrderStatus: "Open",
                            IsBuyerRequestedCancellation:  String(row[51]),
                            BuyerRequestedCancelReason: row[52],
                            Items: [],
                        };
                    }
                    console.log("Extracted Order Data:", ordersMap[orderId]); // Log extracted order data
                   
                    // Check if item with same SKU exists
                    const existingItem = ordersMap[orderId].Items.find(
                        (item) => item.SKU === sku
                    );
                    if (existingItem) {
                        // Sum quantities if SKU matches
                        existingItem.QuantityPurchased += quantity;
                    } else {
                        // Add new item if SKU doesn't exist
                        ordersMap[orderId].Items.push({
                            OrderItemId: orderId + "-" + orderItemId,
                            SKU: sku,
                            ProductName: row[10],
                            QuantityPurchased: quantity,
                            ItemPrice: parseFloat(row[13]),
                            ItemTax: parseFloat(row[14]),
                        });
                    }
                });


                const groupedOrders = Object.values(ordersMap).filter(
                    (order) => order.ShipCountry === "US" 
                );
                setAllOrders(prev => [...prev, ...groupedOrders]); // Append new orders
                setTimeout(() => handlePreviewAllOrders(groupedOrders), 500);
            }
        });
        return false; // Prevent automatic upload
    };

    const itemColumns = [
        {
            title: "SKU",
            dataIndex: "SKU",
            key: "SKU",
            width: 150,
        },
        {
            title: "Product Name",
            dataIndex: "ProductName",
            key: "ProductName",

        },
        {
            title: "Quantity",
            dataIndex: "QuantityPurchased",
            key: "QuantityPurchased",
            width: 150,
        },
        {
            title: "Price",
            dataIndex: "ItemPrice",
            key: "ItemPrice",
            width: 150,
        },
        {
            title: "Tax",
            dataIndex: "ItemTax",
            key: "ItemTax",
            width: 150,
        },
    ];




    const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderId",
            key: "OrderId",
            width: 'auto',
        },
        // {
        //     title: "Order Item ID",
        //     dataIndex: "OrderItemId",
        //     key: "OrderItemId",
        //     width: 150,
        // },
        {
            title: "Purchase Date",
            dataIndex: "PurchaseDate",
            key: "PurchaseDate",
            width: 'auto',
            render: (date) => date ? toLocalDateTime(date, "YYYY-MM-DD HH:mm:ss") : "",
        },
        // {
        //     title: "Payments Date",
        //     dataIndex: "PaymentsDate",
        //     key: "PaymentsDate",
        //     width: 150,
        // },
        {
            title: "Buyer Email",
            dataIndex: "BuyerEmail",
            key: "BuyerEmail",
            width: 150,
        },
        {
            title: "Buyer Name",
            dataIndex: "BuyerName",
            key: "BuyerName",
            width: 150,
        },
        // {
        //     title: "Payment Method Details",
        //     dataIndex: "PaymentMethodDetails",
        //     key: "PaymentMethodDetails",
        //     width: 200,
        // },
        {
            title: "Buyer Phone Number",
            dataIndex: "BuyerPhoneNumber",
            key: "BuyerPhoneNumber",
            width: 150,
        },

        // {
        //     title: "Number of Items",
        //     dataIndex: "NumberOfItems",
        //     key: "NumberOfItems",
        //     width: 150,
        // },
        {
            title: "Currency",
            dataIndex: "Currency",
            key: "Currency",
            width: 100,
        },
        {
            title: "Shipping Price",
            dataIndex: "ShippingPrice",
            key: "ShippingPrice",
            width: 150,
        },
        {
            title: "Shipping Tax",
            dataIndex: "ShippingTax",
            key: "ShippingTax",
            width: 150,
        },
        // {
        //     title: "Gift Wrap Price",
        //     dataIndex: "GiftWrapPrice",
        //     key: "GiftWrapPrice",
        //     width: 150,
        // },
        // {
        //     title: "Gift Wrap Tax",
        //     dataIndex: "GiftWrapTax",
        //     key: "GiftWrapTax",
        //     width: 150,
        // },
        {
            title: "Ship Service Level",
            dataIndex: "ShipServiceLevel",
            key: "ShipServiceLevel",
            width: 200,
        },
        // {
        //     title: "Ship Service Name",
        //     dataIndex: "ShipServiceName",
        //     key: "ShipServiceName",
        //     width: 200,
        // },
        {
            title: "Recipient Name",
            dataIndex: "RecipientName",
            key: "RecipientName",
            width: 200,
        },
        {
            title: "Ship Address 1",
            dataIndex: "ShipAddress1",
            key: "ShipAddress1",
            width: 200,
        },
        {
            title: "Ship Address 2",
            dataIndex: "ShipAddress2",
            key: "ShipAddress2",
            width: 200,
        },
        {
            title: "Ship Address 3",
            dataIndex: "ShipAddress3",
            key: "ShipAddress3",
            width: 200,
        },
        {
            title: "Address Type",
            dataIndex: "AddressType",
            key: "AddressType",
            width: 150,
        },
        {
            title: "Ship City",
            dataIndex: "ShipCity",
            key: "ShipCity",
            width: 150,
        },
        {
            title: "Ship State",
            dataIndex: "ShipState",
            key: "ShipState",
            width: 150,
        },
        {
            title: "Ship Postal Code",
            dataIndex: "ShipPostalCode",
            key: "ShipPostalCode",
            width: 150,
        },
        {
            title: "Ship Country",
            dataIndex: "ShipCountry",
            key: "ShipCountry",
            width: 150,
        },
        {
            title: "Ship Phone Number",
            dataIndex: "ShipPhoneNumber",
            key: "ShipPhoneNumber",
            width: 150,
        },
        {
            title: "Is Buyer Requested Cancellation",
            dataIndex: "IsBuyerRequestedCancellation",
            key: "IsBuyerRequestedCancellation",
            width: 150,
        },
        {
            title: "Buyer Requested Cancel Reason",
            dataIndex: "BuyerRequestedCancelReason",
            key: "BuyerRequestedCancelReason",
            width: 150,
        },
        {
            title: "Order Status",
            dataIndex: "OrderStatus",
            key: "OrderStatus",
            width: 150,
        },
        {
            title: "Action",
            dataIndex: "Id",
            key: "x",
            width: 100,
            fixed: 'right', // Make the Action column static
            render: (x, item) =>
                ActionMenu({
                    onClick: (action) => {
                        onAction({ action, item });
                    },
                }),
        },
    ];


    const ActionMenu = (props) => {
        return (
            <Dropdown overlay={menu(props)} placement="bottomLeft">
                <Button>
                    <MenuOutlined />
                </Button>
            </Dropdown>
        );
    };

    const menu = (props) => {
        return (
            <Menu
                items={[
                   
                    {
                        key: "EDIT",
                        label: "Edit",
                        onClick: () => props.onClick("EDIT"),
                    },
                     {
                        key: "DELETE",
                        label: "Delete",
                        onClick: () => props.onClick("DELETE"),
                    },
                    // {
                    //     key: "SAVE",
                    //     label: "Save",
                    //     onClick: () => props.onClick("SAVE"),
                    // },
                ]}
            />
        );
    };

    return (
        <Card title="Uploaded Orders" style={{ height: '100%' }}>
            <Upload
                beforeUpload={handleFileUpload}
                showUploadList={false}
            >
                <Button icon={<UploadOutlined />}>Upload Excel</Button>
            </Upload>

            <Button

                onClick={() => handleSaveOrder(allOrders)}
                style={{ marginLeft: 10, marginBottom: 16 }}
            >
                Save All Orders
            </Button>

            <EditOrderModel
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                form={form} // Pass the parent's form instance
                editingOrder={editingOrder}
                onUpdate={handleUpdateOrder} // Pass the update handler
            />

            <div style={{ marginTop: 16 }}>
                <Table
                    columns={columns}
                    dataSource={allOrders}
                    rowKey="OrderId"
                    loading={loading}
                    scroll={{ x: 'max-content', y: 'calc(100vh - 200px)' }}
                    expandable={{
                        expandIcon: ({ expanded, onExpand, record }) =>
                            record.Items?.length > 0 ? (
                                <Button
                                    type="text"
                                    onClick={(e) => onExpand(record, e)}
                                    icon={expanded ? '-' : '+'}
                                />
                            ) : null,
                        expandedRowRender: (record) => (
                            <Table
                                columns={itemColumns}
                                dataSource={record.Items}
                                rowKey="SKU"
                                pagination={false}
                                scroll={{ x: '100%' }}
                            />
                        ),
                        rowExpandable: (record) => record.Items && record.Items.length > 0,
                    }}
                />
            </div>
        </Card>
    );
};

export default UploadedOrdersTab;